export default function ReportIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      style={{display:"block",height:"24px",width:"24px",fill:"currentColor"}}
      aria-hidden="true"
      role="presentation"
      focusable="false"
    >
      <path d="M16 1a11 11 0 0 1 10.6 8.03 6 6 0 0 1-.34 11.96 11.01 11.01 0 0 1-7.53 6.7l.2-.05a3 3 0 1 1-.26-2.01 9 9 0 0 0 6.33-8.6V12a9 9 0 0 0-18-.27V21H6a6 6 0 0 1-.6-11.97A11 11 0 0 1 16 1zm0 25a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM5 11.13l-.15.04a4 4 0 0 0 0 7.66l.15.04v-7.74zm22 0v7.74l.15-.04a4 4 0 0 0 0-7.66l-.15-.04z"></path>
    </svg>
  );
}
